import Highcharts from 'highcharts';

// Global Highcharts configuration
Highcharts.setOptions({
  // Disable accessibility warnings
  accessibility: {
    enabled: false
  },
  
  // Global chart styling and defaults
  chart: {
    backgroundColor: 'transparent',
    style: {
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif'
    }
  },
  
  // Default colors that match Stackry branding
  colors: [
    '#36c6d3', // Stackry teal
    '#ff6b6b', // Red
    '#4ecdc4', // Light teal
    '#45b7d1', // Blue
    '#96ceb4', // Green
    '#feca57', // Yellow
    '#ff9ff3', // Pink
    '#54a0ff', // Light blue
    '#5f27cd', // Purple
    '#00d2d3'  // Cyan
  ],
  
  // Default title styling
  title: {
    style: {
      color: '#333333',
      fontSize: '18px',
      fontWeight: 'bold'
    }
  },
  
  // Default legend styling
  legend: {
    itemStyle: {
      color: '#333333'
    }
  },
  
  // Default tooltip styling
  tooltip: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderColor: '#cccccc',
    borderRadius: 4,
    shadow: true
  },
  
  // Default plot options
  plotOptions: {
    series: {
      animation: {
        duration: 800
      }
    }
  }
});

export default Highcharts; 